import { generateTypes } from '../../utils/HttpReducerHelper';

export const network = generateTypes('NETWORK_SIGNUP', 'NETWORK');
export const signupNetwork = generateTypes('NETWORK_SIGNUP', 'SIGNUP');
